import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import Vuex from 'vuex';

import sharedPlugins from '@d-shared/plugins';
import Device from '@d-shared/utils/device';
import UI from '@dui/full-ui';

import components from './components';
import storeModules from './store';

import '../styles/application.scss';
import '../styles/public-app.scss';

export default function() {
  if (Device.isiOS()) {
    document.body.classList.add('ios-device');
  }

  Vue.use(Vuex);
  UI.installInVueInstance();

  sharedPlugins.forEach((plugin) => {
    Vue.use(plugin);
  });

  Vue.use(VueScrollTo);
  Vue.use(PortalVue);

  const store = new Vuex.Store({
    modules: storeModules,
  });

  new Vue({
    el: '#discovery-app',
    store: store,
    components: components,
  });
};
